import { getObjectValueByPath } from "vuetify/lib/util/helpers";

export default {
	name: "BroadcastableMixin",

	data: () => ( {
		enabled: Boolean( process.env.VUE_APP_SOCKET_URL )
	} ),

	computed: {
		broadcastsArr() {
			return [].concat( this.broadcasts || [] );
		},

		token() {
			return this.$auth.token();
		},

		crudMethodMap() {
			return {
				c: this.broadcastCreator,
				r: this.broadcastRefresher,
				u: this.broadcastUpdater,
				d: this.broadcastDeleter
			};
		}
	},

	watch: {
		token: {
			handler( token ) {
				if ( this.enabled ) {
					this.$echo.connector.options.auth.headers.Authorization = `Bearer ${token}`;
				}
			},
			immediate: true
		},

		broadcastsArr: {
			handler( val = [], oldVal = [] ) {
				const newChannels = val.filter( item =>
					!oldVal.find( oldItem => oldItem.channel === item.channel )
				);
				const oldChannels = oldVal.filter( oldItem =>
					!val.find( item => oldItem.channel === item.channel )
				);

				this.unlisten( oldChannels );
				this.listen( newChannels );
			},
			immediate: true
		}
	},

	methods: {
		transformBroadcastData( broadcast, data ) {
			if ( typeof broadcast.Model === "function" ) {
				if ( Array.isArray( data ) ) {
					return data.map( item => new broadcast.Model( item ) );
				}

				return new broadcast.Model( data );
			}

			return data;
		},

		broadcastCreator( broadcast, data ) {
			const propKey = broadcast.propKey;
			const broadcastData = this.transformBroadcastData( broadcast, data );

			if ( Array.isArray( broadcast.propParent[propKey] ) ) {
				if ( broadcast.propParent[propKey].findIndex(
					item => item.id === broadcastData.id
				) === -1 ) {
					broadcast.propParent[propKey].push( broadcastData );
				}
			} else {
				this.$set(
					broadcast.propParent,
					propKey,
					broadcastData
				);
			}
		},

		broadcastRefresher( broadcast, data ) {
			const propKey = broadcast.propKey;

			this.$set(
				broadcast.propParent,
				propKey,
				this.transformBroadcastData( broadcast, data )
			);
		},

		broadcastUpdater( broadcast, data ) {
			const propKey = broadcast.propKey;

			if ( Array.isArray( broadcast.propParent[propKey] ) ) {
				const updateIndex = broadcast.propParent[propKey].findIndex( d => data.id === d.id );

				if ( updateIndex === -1 ) {
					this.broadcastCreator( broadcast, data );
				} else {
					this.$set(
						broadcast.propParent[propKey],
						updateIndex,
						this.transformBroadcastData( broadcast, data )
					);
				}
			} else {
				this.broadcastRefresher( broadcast, data );
			}
		},

		broadcastDeleter( broadcast, data ) {
			const propKey = broadcast.propKey;

			if ( Array.isArray( broadcast.propParent[propKey] ) ) {
				const deleteIndex = broadcast.propParent[propKey].findIndex( d => data.id === d.id );

				if ( deleteIndex !== -1 ) {
					this.$delete( broadcast.propParent[propKey], deleteIndex );
				}
			} else {
				this.$set(
					broadcast.propParent,
					propKey,
					null
				);
			}
		},

		listen( broadcasts ) {
			if ( !this.enabled ) {
				return;
			}

			broadcasts.forEach( broadcast => {
				broadcast.propParent = broadcast.hasOwnProperty( "propPath" )
					? getObjectValueByPath( this, broadcast.propPath )
					: this;

				Object.keys( broadcast.eventNames ).forEach( crudType => {
					this.$echo.private( broadcast.channel ).listen( `.${broadcast.eventNames[crudType]}`,
						( { data } ) => this.crudMethodMap[crudType]( broadcast, data )
					);
				} );
			} );
		},

		unlisten( broadcasts ) {
			if ( !this.enabled ) {
				return;
			}

			broadcasts.forEach( broadcast => {
				this.$echo.leave( broadcast.channel );
			} );
		}
	},

	beforeDestroy() {
		if ( this.broadcasts ) {
			this.unlisten( this.broadcastsArr );
		}
	}
};
